/**
 * Treatment & Conditions Block
 *
 * @package Embark
 * @since   1.0.0
 */

import 'whatwg-fetch';
import { buildQuery } from '../doctor-finder/params.js';
import { results, noResults } from './template';

const initTreatmentsConditions = () => {
	const { restUrl } = window.EmClient;
	const apiUrl = `${restUrl}em/v1/home-search`;
	const homeSearch = document.querySelectorAll('.em-home-search');

	homeSearch.forEach((block) => {
		const navItems = block.querySelectorAll('.em-home-search__tabs-nav > div');
		const tabs = block.querySelectorAll('.em-home-search__tabs-content > div');
		const search = block.querySelector('form');
		const searchInput = block.querySelector('input');
		const letters = block.querySelectorAll('.letter');
		const browseResults = block.querySelector('.em-home-search__browse .em-home-search__results');

		const tabLogic = (item) => {
			const tab = block.querySelector(`.em-home-search__tabs-content [data-tab="${item.dataset.tab}"]`);

			navItems.forEach((item) => {
				item.classList.remove('active');
			});

			tabs.forEach((tab) => {
				tab.classList.remove('active');
			});

			item.classList.add('active');
			tab.classList.add('active');
		};

		navItems.forEach((item) => {
			item.onclick = () => {
				tabLogic(item);
			};

			item.onkeyup = (e) => {
				if (e.code === 'Enter') {
					tabLogic(item);
				}
			};
		});

		const resultCount = (count) => `
			<div class="em-col-12">
				<h4>${count} Results</h4>
			</div>
			`;

		const searchQuery = (input) => {
			const { value } = input;

			if (value.length > 2) {
				(async () => {
					const params = {
						search: value,
					};
					// Fetch the posts.
					const response = await fetch(apiUrl + buildQuery(params));
					let data = await response.json();
					data = data ? JSON.parse(data) : false;

					if (data.found_posts) {
						let html = resultCount(data.found_posts);
						const { posts } = data;

						posts.forEach((post) => {
							html += results(post);
						});

						search.nextElementSibling.innerHTML = html;
					} else {
						search.nextElementSibling.innerHTML = noResults('No Results found. Please try another search.');
					}
				})();
			}

			if (!value) {
				search.nextElementSibling.innerHTML = '';
			}
		};

		search.onsubmit = (e) => {
			e.preventDefault();
			searchQuery(searchInput);
		};

		searchInput.onkeyup = () => {
			searchQuery(searchInput);
		};

		const letterLogic = (letter) => {
			letters.forEach((letter) => { letter.classList.remove('active'); });

			if (!letter.classList.contains('disabled')) {
				letter.classList.add('active');
				(async () => {
					const { postIds, termIds } = letter.dataset;
					const params = {
						termIds,
						postIds: postIds || '',
					};
					// Fetch the posts.
					const response = await fetch(apiUrl + buildQuery(params));
					let data = await response.json();
					data = data ? JSON.parse(data) : false;

					if (data.found_posts) {
						let html = resultCount(data.found_posts);
						const { posts } = data;

						posts.forEach((post) => {
							html += results(post);
						});

						browseResults.innerHTML = html;
					} else {
						browseResults.innerHTML = noResults('No Results found. Please try another search.');
					}
				})();
			}
		};

		letters.forEach((letter) => {
			letter.onclick = () => {
				letterLogic(letter);
			};

			letter.onkeyup = (e) => {
				if (e.code === 'Enter') {
					letterLogic(letter);
				}
			};
		});
	});
};

document.addEventListener('DOMContentLoaded', initTreatmentsConditions);
